import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DaoService } from '../servicos/dao.service';

@Component({
  selector: 'app-consulta-censo',
  templateUrl: './consulta-censo.component.html',
  styleUrls: ['./consulta-censo.component.css']
})
export class ConsultaCensoComponent implements OnInit {

  constructor(public dao:DaoService,private route: ActivatedRoute) { }
  censo: any;
  secretaria:any;
  ss:any;
  unidades:any;
  filtro:any;
  filt:any;
  ngOnInit() {
    this.ss = this.route.params.subscribe(params => {
      this.censo = params['censo']; // (+) converts string 'id' to a number
      this.secretaria = params['secretaria'];
      // In a real app: dispatch action to load the details here.
      console.log(this.censo,this.secretaria);
      
      this.iniciar();
   });
  }

  filtrando(){
    console.log("Filtrando...")
    if(!this.filt || this.filt.length==0){
      this.filtro = this.unidades;
      return;
    }
    
    if(this.filt && this.filt.length<2)return;
    this.filtro = this.unidades.filter(un=>{
      if((un.nome.toLowerCase()).includes(this.filt.toLowerCase()))return un;
      if(((un.secretaria+'').toLowerCase()).includes(this.filt.toLowerCase()))return un;
      if(((un.situacao+'').toLowerCase()).includes(this.filt.toLowerCase()))return un;
    })
  }

  async iniciar(){
    if(this.secretaria!='todas' && this.secretaria!='outras'){
      let dados = {censo:this.censo,secretaria:this.secretaria};
      console.log("DADOS", dados);
      this.unidades = await this.dao.submeterSite(dados,'getUnidadePorCensoSecretaria');
      this.filtro = this.unidades;
      return;
    }


    if(this.secretaria =='outras'){
      let dados = {censo:this.censo,secretaria:this.secretaria};
      console.log("DADOS", dados);
      this.unidades = await this.dao.submeterSite(dados,'getUnidadePorCensoOutros');
      this.filtro = this.unidades;
      return;
    }

    this.unidades = await this.dao.submeterSite({censo:this.censo},'getUnidadePorCensoTodas');
    
    this.filtro = this.unidades;
  }

}
